import { CartAddEvent } from '@theme/events';

/**
 * Handles the "+ Add" buttons in the cart drawer's "People also bought" row (snippets/cart-upsell.liquid).
 * Adds the variant to the cart, then dispatches the same event the product form does,
 * so the drawer re-renders and the cart bubble updates.
 */
document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-cart-upsell-add]') : null;
  if (!(button instanceof HTMLButtonElement) || button.getAttribute('aria-busy') === 'true') return;

  button.setAttribute('aria-busy', 'true');

  const sectionIds = [];
  for (const item of document.querySelectorAll('cart-items-component')) {
    if (item instanceof HTMLElement && item.dataset.sectionId) {
      sectionIds.push(item.dataset.sectionId);
    }
  }

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });
    const data = await response.json();

    if (data.status) throw new Error(data.description || data.message);

    const cart = await fetch('/cart.js').then((cartResponse) => cartResponse.json());

    document.dispatchEvent(
      new CartAddEvent(cart, 'cart-upsell', {
        source: 'cart-upsell',
        itemCount: cart.item_count,
        variantId: button.dataset.variantId,
        sections: data.sections,
      })
    );
  } catch (error) {
    console.error(error);
    button.removeAttribute('aria-busy');
  }
});
